import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'aionz-quotation-map-meta-skeleton',
  templateUrl: './quotation-map-meta-skeleton.component.html',
  styleUrl: './quotation-map-meta-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuotationMapMetaSkeletonComponent {}
